import { render } from "./update-avatar.vue?vue&type=template&id=ea87a3a6&scoped=true&ts=true"
import script from "./update-avatar.vue?vue&type=script&lang=ts"
export * from "./update-avatar.vue?vue&type=script&lang=ts"

import "./update-avatar.vue?vue&type=style&index=0&id=ea87a3a6&lang=scss"
import "./update-avatar.vue?vue&type=style&index=1&id=ea87a3a6&scoped=true&lang=scss"

import exportComponent from "/Applications/MAMP/htdocs/wrf.com/wrf-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea87a3a6"]])

export default __exports__